import React from 'react'
import { TextField, BooleanField } from 'react-admin'
import { ListGuesser } from 'theme/components'

export const ShippingCountryStoreList = (props) => (
  <ListGuesser
    {...props}
    filter={{
      properties: ['id', 'name', 'enabledInPortal'],
      'properties[store]': ['name'],
      'properties[country]': ['name'],
    }}
    rowClick="edit"
  >
    <TextField
      source="originId"
      label="id"
      sortBy="id"
      sort={{ field: 'id', order: 'DESC' }}
    />
    <TextField source="country.name" label="Country" />
    <TextField source="name" label="Translated country name" />
    <TextField source="store.name" label="Store" />
    <BooleanField source="enabledInPortal" />
  </ListGuesser>
)
